import {router} from '@inertiajs/react';
import React, {createContext, useContext, useEffect, useState} from 'react';

const PageLoadingContext = createContext({page_loading: false, setPageLoading: () => {}});

export const PageLoadingProvider = ({children}) => {
    const [pageLoading, setPageLoading] = useState(false);
    let timeout = null;

    useEffect(() => {
        const removeStartListener = router.on('start', () => {
            timeout = setTimeout(() => setPageLoading(true), 250);
        });

        const removeFinishListener = router.on('finish', () => {
            clearTimeout(timeout);
            setPageLoading(false);
        });

        return () => {
            removeStartListener();
            removeFinishListener();
        };
    }, []);

    return (
        <PageLoadingContext.Provider value={{page_loading: !!pageLoading, setPageLoading}}>
            {children}
        </PageLoadingContext.Provider>
    );
};

export const usePageLoading = () => {
    return useContext(PageLoadingContext);
};
